__turbopack_context__.v({
  "backdrop": "PeopleHeroCard-module-scss-module__fPN5Uq__backdrop",
  "badge": "PeopleHeroCard-module-scss-module__fPN5Uq__badge",
  "card": "PeopleHeroCard-module-scss-module__fPN5Uq__card",
  "card--active": "PeopleHeroCard-module-scss-module__fPN5Uq__card--active",
  "image": "PeopleHeroCard-module-scss-module__fPN5Uq__image",
  "imageWrap": "PeopleHeroCard-module-scss-module__fPN5Uq__imageWrap",
  "stack-module-0": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-0",
  "stack-module-1": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-1",
  "stack-module-10": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-10",
  "stack-module-11": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-11",
  "stack-module-12": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-12",
  "stack-module-13": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-13",
  "stack-module-14": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-14",
  "stack-module-15": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-15",
  "stack-module-16": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-16",
  "stack-module-17": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-17",
  "stack-module-18": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-18",
  "stack-module-19": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-19",
  "stack-module-2": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-2",
  "stack-module-20": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-20",
  "stack-module-3": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-3",
  "stack-module-4": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-4",
  "stack-module-5": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-5",
  "stack-module-6": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-6",
  "stack-module-7": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-7",
  "stack-module-8": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-8",
  "stack-module-9": "PeopleHeroCard-module-scss-module__fPN5Uq__stack-module-9",
  "z-base": "PeopleHeroCard-module-scss-module__fPN5Uq__z-base",
  "z-content": "PeopleHeroCard-module-scss-module__fPN5Uq__z-content",
  "z-footer": "PeopleHeroCard-module-scss-module__fPN5Uq__z-footer",
  "z-header": "PeopleHeroCard-module-scss-module__fPN5Uq__z-header",
  "z-hero": "PeopleHeroCard-module-scss-module__fPN5Uq__z-hero",
  "z-logo": "PeopleHeroCard-module-scss-module__fPN5Uq__z-logo",
  "z-logo-effect": "PeopleHeroCard-module-scss-module__fPN5Uq__z-logo-effect",
  "z-navigation": "PeopleHeroCard-module-scss-module__fPN5Uq__z-navigation",
  "z-sub": "PeopleHeroCard-module-scss-module__fPN5Uq__z-sub",
});
